var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "collapsible-section"
  }, [_c('div', {
    staticClass: "collapsible-header",
    on: {
      "click": _vm.togglereasonSubSection
    }
  }, [_c('span', {
    staticClass: "toggle-icon"
  }, [_vm._v(_vm._s(_vm.isreasonsubreasonSectionOpen ? '▼' : '▶'))]), _vm._v(" "), _c('h2', [_vm._v("Reason Sub-reason configuration")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isreasonsubreasonSectionOpen),
      expression: "isreasonsubreasonSectionOpen"
    }],
    staticClass: "collapsible-content"
  }, [_c('div', {
    staticClass: "filter-config-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "0.5rem",
      "color": "#666"
    }
  }, [_vm._v("\n          Select filters to narrow down the dispute proof configurations.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-row"
  }, [_c('div', [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "shipmentType",
      "options": _vm.shipmentTypeList,
      "placeholder": "All",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.reasonSubReason
    },
    model: {
      value: (_vm.shipmentType),
      callback: function($$v) {
        _vm.shipmentType = $$v
      },
      expression: "shipmentType"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Dispute Reason")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "reason",
      "options": _vm.reasonList,
      "placeholder": "All",
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Dispute Sub-Reason")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "subreason",
      "options": _vm.subReasonMap[_vm.reason.value] || [],
      "placeholder": "All",
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.subreason),
      callback: function($$v) {
        _vm.subreason = $$v
      },
      expression: "subreason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-end"
    }
  }, [_c('button', {
    staticClass: "reset-btn",
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("Reset Filters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "configuration-table-container"
  }, [_c('h2', [_vm._v("Configuration Table")]), _vm._v(" "), _c('p', [_vm._v("\n          Toggle switches to set image or video proofs as mandatory for a specific reason and sub-reason.\n        ")]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.filteredTableData.length === 0) ? _c('tr', {
    staticClass: "no-results-row"
  }, [_c('td', {
    staticClass: "no-results-cell",
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "no-results-content"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('p', [_vm._v("No configurations found matching the selected filters")]), _vm._v(" "), _c('button', {
    staticClass: "clear-filters-btn",
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("\n                    Clear Filters\n                  ")])])])]) : _vm._l((_vm.filteredTableData), function(row, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(row.shipmentType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.subreason))]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.imageProofMandatory),
        expression: "row.imageProofMandatory"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(row.imageProofMandatory) ? _vm._i(row.imageProofMandatory, null) > -1 : (row.imageProofMandatory)
      },
      on: {
        "__c": function($event) {
          var $$a = row.imageProofMandatory,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (row.imageProofMandatory = $$a.concat($$v))
            } else {
              $$i > -1 && (row.imageProofMandatory = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            row.imageProofMandatory = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider"
    })])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoProofMandatory),
        expression: "row.videoProofMandatory"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(row.videoProofMandatory) ? _vm._i(row.videoProofMandatory, null) > -1 : (row.videoProofMandatory)
      },
      on: {
        "__c": function($event) {
          var $$a = row.videoProofMandatory,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (row.videoProofMandatory = $$a.concat($$v))
            } else {
              $$i > -1 && (row.videoProofMandatory = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            row.videoProofMandatory = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      class: {
        'enabled-btn': _vm.hasProofChanged(row),
        'disabled-btn': !_vm.hasProofChanged(row)
      },
      attrs: {
        "disabled": !_vm.hasProofChanged(row)
      },
      on: {
        "click": function($event) {
          _vm.updateProofsConfig(row, "reasonsubreason-config")
        }
      }
    }, [_vm._v("\n                  Update\n                ")])])])
  })], 2)])]), _vm._v(" "), (_vm.reasonsubreasonData.length) ? _c('div', {
    staticClass: "audit-trail-section"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "audit-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.reasonsubreasonData), function(entry, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(entry.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s([entry.log.shipmenttype, entry.log.reason, entry.log.subreason].filter(Boolean).join(' / ')) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.setting))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.oldvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.newvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.createdby))])])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "collapsible-section"
  }, [_c('div', {
    staticClass: "collapsible-header",
    on: {
      "click": _vm.toggleClientSection
    }
  }, [_c('span', {
    staticClass: "toggle-icon"
  }, [_vm._v(_vm._s(_vm.isClientSectionOpen ? '▼' : '▶'))]), _vm._v(" "), _c('h2', [_vm._v("Client WH Handover Dispute Proof Configurations")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClientSectionOpen),
      expression: "isClientSectionOpen"
    }],
    staticClass: "collapsible-content"
  }, [_c('div', {
    staticClass: "global-tat-card"
  }, [_c('h2', [_vm._v(" Global Default TAT Settings")]), _vm._v(" "), _c('div', {
    staticClass: "tat-inputs"
  }, [_c('div', [_c('div', [_vm._v("\n              Default Dispute Opening TAT (Days):\n              "), _c('strong', [_vm._v(_vm._s(_vm.globalTat.opening))]), _vm._v(" days\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("\n              Default Dispute Reopening TAT (Days):\n              "), _c('strong', [_vm._v(_vm._s(_vm.globalTat.reopening))]), _vm._v(" days\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "configuration-table-container"
  }, [_c('h2', [_vm._v("Configuration Table")]), _vm._v(" "), _c('p', [_vm._v("\n          Update Client WH Handover Dispute Proof settings below\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search by Client Name"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.searchQuery.trim().length > 0 && _vm.searchQuery.trim().length < 4
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" Search\n          ")]), _vm._v(" "), (_vm.searchQuery.trim().length > 0) ? _c('button', {
    staticClass: "btn btn-sm custom-reset-btn",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v("\n            Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.searchQuery.trim().length > 0 && _vm.searchQuery.trim().length < 4) ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            Minimum 4 characters required to search by client name\n          ")]) : _vm._e()]), _vm._v(" "), _c('table', [_vm._m(4), _vm._v(" "), _c('tbody', [(_vm.clientTableData.length === 0) ? _c('tr', {
    staticClass: "no-results-row"
  }, [_vm._m(5)]) : _vm._l((_vm.clientTableData), function(client, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.itemsPerPage + idx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.clientid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.clientbusinessaccountid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.clientbusinessaccountname))]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (client.isvideo),
        expression: "client.isvideo"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(client.isvideo) ? _vm._i(client.isvideo, null) > -1 : (client.isvideo)
      },
      on: {
        "__c": function($event) {
          var $$a = client.isvideo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (client.isvideo = $$a.concat($$v))
            } else {
              $$i > -1 && (client.isvideo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            client.isvideo = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider"
    })])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (client.isimage),
        expression: "client.isimage"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(client.isimage) ? _vm._i(client.isimage, null) > -1 : (client.isimage)
      },
      on: {
        "__c": function($event) {
          var $$a = client.isimage,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (client.isimage = $$a.concat($$v))
            } else {
              $$i > -1 && (client.isimage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            client.isimage = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "tat-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (client.disputehours),
        expression: "client.disputehours"
      }],
      staticClass: "tat-input",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "30"
      },
      domProps: {
        "value": (client.disputehours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          client.disputehours = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "tat-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (client.reopenhours),
        expression: "client.reopenhours"
      }],
      staticClass: "tat-input",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "30"
      },
      domProps: {
        "value": (client.reopenhours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          client.reopenhours = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      class: {
        'enabled-btn': _vm.hasClientProofChanged(client),
        'disabled-btn': !_vm.hasClientProofChanged(client)
      },
      attrs: {
        "disabled": !_vm.hasClientProofChanged(client)
      },
      on: {
        "click": function($event) {
          _vm.updateClientProofsConfig(idx, "client-config")
        }
      }
    }, [_vm._v("\n                  Update\n                ")])])])
  })], 2)]), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "pagination-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.totalPages) + " (" + _vm._s(_vm.totalItems) + " records)")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.currentPage === _vm.totalPages
    },
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()]), _vm._v(" "), (_vm.clientData.length) ? _c('div', {
    staticClass: "audit-trail-section"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "audit-table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.clientData), function(entry, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(entry.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.clientname) + "(" + _vm._s(entry.log.clientid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.clientbusinessaccountname) + "(" + _vm._s(entry.log.clientbusinessaccountid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.setting))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.oldvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.log.newvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.createdby))])])
  }))])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("🔍")]), _vm._v("\n          Filter Configurations\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Dispute Reason")]), _vm._v(" "), _c('th', [_vm._v("Dispute Sub-Reason")]), _vm._v(" "), _c('th', [_vm._v("Image Proof Mandatory")]), _vm._v(" "), _c('th', [_vm._v("Video Proof Mandatory")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit-header"
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h2', [_vm._v("Reason Sub-reason Audit Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "audit-description"
  }, [_vm._v("History of configuration changes made to proof requirements.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Configuration")]), _vm._v(" "), _c('th', [_vm._v("Setting")]), _vm._v(" "), _c('th', [_vm._v("Old Value")]), _vm._v(" "), _c('th', [_vm._v("New Value")]), _vm._v(" "), _c('th', [_vm._v("Changed By")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("S.No.")]), _vm._v(" "), _c('th', [_vm._v("Parent Client ID")]), _vm._v(" "), _c('th', [_vm._v("Parent Client Name")]), _vm._v(" "), _c('th', [_vm._v("Child Client ID")]), _vm._v(" "), _c('th', [_vm._v("Child Client Name")]), _vm._v(" "), _c('th', [_vm._v("Video Upload")]), _vm._v(" "), _c('th', [_vm._v("Image Upload")]), _vm._v(" "), _c('th', [_vm._v("Dispute Opening TAT (Days)")]), _vm._v(" "), _c('th', [_vm._v("Dispute Reopening TAT (Days)")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "no-results-cell",
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "no-results-content"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('p', [_vm._v("No configurations found ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit-header"
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h2', [_vm._v("Client Audit Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "audit-description"
  }, [_vm._v("History of configuration changes made to proof requirements.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Parent Client")]), _vm._v(" "), _c('th', [_vm._v("Child Client")]), _vm._v(" "), _c('th', [_vm._v("Setting")]), _vm._v(" "), _c('th', [_vm._v("Old Value")]), _vm._v(" "), _c('th', [_vm._v("New Value")]), _vm._v(" "), _c('th', [_vm._v("Changed By")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29eb5c13","hasScoped":true}!./src/views/components/DisputeConfigurations/DisputeConfigurations.component.html
// module id = 647
// module chunks = 1